import { render, staticRenderFns } from "./IncludeTrainLayout.vue?vue&type=template&id=2deba527"
import script from "./IncludeTrainLayout.vue?vue&type=script&lang=js"
export * from "./IncludeTrainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports